import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";
import RentImageViewer from "../components/RentImageViewer";
import { Row } from "antd";

function ReturnAddImage() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();
    const [rent, setRent] = useState<Types.RentDto>();

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
    }, [params.rentId]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);

        currentRentId && requestGetRent();

        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        };
    }, [currentRentId]);

    const requestAxiosGetRent = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + currentRentId);
        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;
        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    useEffect(() => {
        if (rent === undefined) return;

        const rentImageList = rent.rentImages;
        if (
            rentImageList.filter(
                (imageItem) => imageItem.imageUploader === "MANAGER" && imageItem.uploadTiming === "END" && imageItem.direction !== null
            ).length === 5
        ) {
            Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);
        } else {
            Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, false);
        }
    }, [rent]);

    const onChangedRentImage = () => {
        currentRentId && requestGetRent();
    };

    const goToNextProcess = () => {
        navigate(Common.PAGE_RETURN_CHECKLIST + "/" + currentRentId);
    };

    return (
        <div>
            <Row>{rent && <RentImageViewer rent={rent} uploader="MANAGER" uploadTiming="END" onChangedRent={onChangedRentImage} />}</Row>
        </div>
    );
}

export default ReturnAddImage;
